"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/*
10/16 = '0.625rem'
11/16 = '0.6875rem'
12/16 = '0.75rem'
14/16 = '0.875rem'
16/16 = '1rem'
18/16 = '1.125rem'
20/16 = '1.25rem'
24/16 = '1.5rem'
30/16 = '1.875rem'
36/16 = '2.25rem'
40/16 = '2.5rem'
48/16 = '3rem'
60/16 = '3.75rem'
72/16 = '4.5rem'

old-standard    40px    20px    16px    12.8px    12px
                2.5rem  1.25rem 1rem    0.8rem    0.75rem

proxima-nova    20px    17.6px  16px    14px        10px
                1.25rem 1.1rem  1rem    0.875rem    0.625rem

saffron too             32px    27.2
                2.5?    2rem    1.7rem  1.5rem  1.25
*/
var plumLight = '#A08EA2';
var plumMedium = '#c3b8c4';
var plumDark = '#aa9bac';
var greyExtraLight = '#EDEDED';
var greyLight = '#DDD';
var greyMedium = '#C0C2C4';
var greyDark = '#6F7072';
var black = '#434244';
var white = '#fff';
var serif = 'old-standard,Times New Roman, serif';
var sans = 'proxima-nova,Arial,sans-serif';
var script = 'SaffronToo';
var theme = {
  palette: {
    primary: {
      light: plumLight,
      medium: plumMedium,
      dark: plumDark
    },
    secondary: {
      light: greyLight,
      medium: greyMedium,
      dark: greyDark
    },
    grey: {
      extraLight: greyExtraLight,
      light: greyLight,
      medium: greyMedium,
      dark: greyDark
    },
    black: black,
    white: white
  },
  spacing: {
    xs: 4,
    sm: 8,
    md: 16,
    lg: 24,
    xl: 44
  },
  typography: {
    h1: {
      fontFamily: serif,
      fontSize: '1.25rem',
      fontWeight: 'normal',
      letterSpacing: '0.1rem',
      textTransform: 'uppercase'
    },
    h2: {
      fontFamily: serif,
      fontSize: '1rem',
      fontWeight: 'normal',
      letterSpacing: 'normal'
    },
    h3: {
      fontFamily: serif,
      fontSize: '1rem',
      fontWeight: 'normal',
      letterSpacing: '0.1rem',
      fontStyle: 'italic'
    },
    h4: {
      fontFamily: sans,
      fontSize: '1.1rem',
      fontWeight: 'normal',
      letterSpacing: '0.11rem',
      textTransform: 'uppercase'
    },
    h5: {
      fontFamily: sans,
      fontSize: '0.85rem',
      fontWeight: 'normal',
      letterSpacing: '0.1rem',
      textTransform: 'uppercase'
    },
    h6: {
      fontFamily: script,
      fontSize: '1.7rem',
      fontWeight: 'normal',
      letterSpacing: 'normal',
      textTransform: 'lowercase'
    },
    subtitle1: {
      fontFamily: sans,
      fontSize: '1rem',
      fontWeight: 300,
      letterSpacing: '0.0625rem'
    },
    subtitle2: {
      fontFamily: serif,
      fontSize: '0.8rem',
      fontWeight: 'normal',
      letterSpacing: 'normal'
    },
    form1: {
      fontFamily: sans,
      fontSize: '0.75rem',
      fontWeight: 'normal',
      textTransform: 'uppercase',
      letterSpacing: '0.075rem'
    },
    form2: {
      fontFamily: serif,
      fontSize: '0.75rem',
      fontWeight: 'normal',
      textTransform: 'uppercase',
      letterSpacing: 'normal'
    },
    body1: {
      fontFamily: sans,
      fontSize: '0.875rem',
      fontWeight: 300,
      letterSpacing: '0.03rem'
    },
    body2: {
      fontFamily: serif,
      fontStyle: 'italic',
      fontSize: '0.8rem',
      fontWeight: 300
    },
    button1: {
      fontFamily: serif,
      fontSize: '1.25rem',
      fontWeight: 'normal',
      letterSpacing: 'normal',
      textTransform: 'uppercase'
    },
    button2: {
      fontFamily: sans,
      fontSize: '0.85rem',
      letterSpacing: '0.09rem',
      textTransform: 'uppercase',
      fontWeight: 'normal'
    },
    caption: {
      fontFamily: sans,
      fontSize: '0.75rem',
      fontWeight: 300,
      letterSpacing: '0.03rem'
    },
    link: {
      fontFamily: sans,
      fontSize: '0.75rem',
      letterSpacing: '0.075rem',
      textTransform: 'uppercase',
      lineHeight: 'inherit',
      cursor: 'pointer',
      textDecoration: 'none'
    },
    callout: {
      fontFamily: serif,
      fontSize: '2.5rem',
      fontWeight: 'normal',
      letterSpacing: 'normal'
    },
    linkUnderlined: {
      '&:hover': {
        textDecoration: 'underline'
      }
    },
    linkPrimary: {
      color: plumMedium,
      '&:hover': {
        color: plumLight
      }
    },
    linkSecondary: {
      color: greyDark,
      '&:hover': {
        color: greyMedium
      }
    },
    fontFamily: {
      serif: serif,
      script: script,
      sans: sans
    }
  }
};

if (process.env.NODE_ENV === 'development') {
  console.log(theme);
}

var _default = theme;
/*
script: {
            fontFamily: 'SaffronToo',
            textTransform: 'lowercase',
            fontSize: '1.7rem',
        },
        scriptPrimary: {
            color: plumMedium,
        },
        scriptSecondary: {
            color: greyDark,
        },
        heading1: {
            textTransform: 'uppercase',
            fontFamily: 'old-standard',
            fontWeight: 400,
            letterSpacing: 0,
            fontSize: '.8rem',
            lineHeight: '1.2rem',
        },
        heading1Primary: {
            color: plumMedium,
        },
        heading1Secondary: {
            color: greyDark,
        },
        heading2: {
            fontFamily: 'old-standard,Times New Roman,serif',
            fontWeight: 500,
            fontStyle: 'italic',
        },
        heading2Primary: {
            color: plumMedium,
        },
        heading2Secondary: {
            color: greyDark,
        },
        body1: {
            fontFamily: 'proxima-nova,Arial,sans-serif',
            letterSpacing: '.03rem',
            fontWeight: 300,
            fontSize: '.875rem',
        },
        body1Primary: {
            color: plumMedium,
        },
        body1Secondary: {
            color: greyDark,
        },
        body2: {
            fontFamily: 'old-standard,Times New Roman,serif',
            letterSpacing: '.05em',
            lineHeight: '1.6em',
            fontWeight: 100,
            fontSize: '.9375em',
        },
        body2Primary: {
            color: plumMedium,
        },
        body2Secondary: {
            color: greyDark,
        },
*/

exports["default"] = _default;